import { take } from './take';

/**
 * Receives an array of items and returns a limited number of items whilst
 * providing information about the original
 */
export class LimitedSet<T> {
  public originalSet: T[];
  constructor(items: T[], private limit: number) {
    this.originalSet = items;
  }

  get limitedSet() {
    return take(this.originalSet, this.limit);
  }

  get totalCount() {
    return this.originalSet.length;
  }
}
